import toggleFavourite from "@casino/actions/Games/toggleFavourite";
import { useState } from "react";

type Args = {
  gameId?: string;
  isFavourite: boolean;
};

// No revalidateTag on purpose: re-rendering the route risks remounting the game iframe.
const useFavourite = ({ gameId, isFavourite }: Args) => {
  const [isOn, setIsOn] = useState(isFavourite);
  const [isSaving, setIsSaving] = useState(false);

  const submitFavourite = async () => {
    if (isSaving || !gameId) return;

    const previous = isOn;

    setIsOn(!previous);
    setIsSaving(true);

    const result = await toggleFavourite({ gameId });

    setIsSaving(false);

    if (result.errors.length) {
      setIsOn(previous);
      return;
    }

    setIsOn(result.isFavourite);
    window.dispatchEvent(new CustomEvent("favouriteToggle"));
  };

  return { isFavourite: isOn, submitFavourite };
};

export default useFavourite;
